import React from 'react';

class SignUpBenefits extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div className="signup-benefits">
        <div className="signup-benefits-body">
          <div className="gradient-divider" />
          <div className="content">
            <div className="title">why choose Promotion Wingman</div>
            <div className="gray-divider" />

            {/* ITEMS */}
            <div className="items">
              <div className="item">
                <i className="material-icons check-icon">check</i>
                <span className="item-description">
                  Spaced repetition increases learning ability
                </span>
              </div>
              <div className="item">
                <i className="material-icons check-icon">check</i>
                <span className="item-description">
                  Free companion apps for iPhone and Android devices
                </span>
              </div>
              <div className="item">
                <i className="material-icons check-icon">check</i>
                <span className="item-description">
                  Study offline from anywhere with our free companion apps
                </span>
              </div>
              <div className="item">
                <i className="material-icons check-icon">check</i>
                <span className="item-description">
                  Q+A paired with references
                </span>
              </div>
              <div className="item">
                <i className="material-icons check-icon">check</i>
                <span className="item-description">
                  Personalized study plan on website to make sure you’re ready
                  in time
                </span>
              </div>
              <div className="item">
                <i className="material-icons check-icon">check</i>
                <span className="item-description">
                  Compare your scores against your peers on our website
                </span>
              </div>
              <div className="item">
                <i className="material-icons check-icon">check</i>
                <span className="item-description">
                  Weekly 100-question practice exams (website only)
                </span>
              </div>
            </div>
          </div>

          {/* MONEY BACK */}
          <div className="money-back">
            <div className="money-back-content">
              <div className="date">
                <div className="number">14</div>
                <div className="time">day</div>
              </div>
              <div className="description">
                Money Back Guarantee For First Time Subscribers
              </div>
            </div>
          </div>

          <div className="content">
            <div className="items-disclaimer">
              {/* DISCLAIMER */}
              <div className="disclaimer">
                If you aren’t satisfied with your Promotion Wingman account,
                contact us at{' '}
                <a href="mailto:support@promotionwingman.com">
                  {' '}
                  support@promotionwingman.com{' '}
                </a>
                within the first 14 days, and we will be happy to refund your
                money. It’s that easy!
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default SignUpBenefits;
